/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="94.95" height="95.43" viewBox="0 0 94.95 95.43" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <path d="M39.94,39.44a33.94,33.94,0,1,0,48.39.4l-.39-.4A34,34,0,0,0,39.94,39.44Zm46.23,1.77a31.18,31.18,0,1,1-.37-.37Z" transform="translate(-30 -29.5)" fill="#0e497b"/><path d="M39.94,39.44a33.94,33.94,0,1,0,48.39.4l-.39-.4A34,34,0,0,0,39.94,39.44Zm46.23,1.77a31.18,31.18,0,1,1-.37-.37Z" transform="translate(-30 -29.5)" fill="#0e497b"/><path d="M62.57,36.23A27.25,27.25,0,0,1,91.15,62.07,1.27,1.27,0,0,1,90,63.39a1.25,1.25,0,0,1-1.31-1.19A24.75,24.75,0,0,0,43.14,50,1.25,1.25,0,0,1,41,48.67,27.22,27.22,0,0,1,62.57,36.23Z" transform="translate(-30 -29.5)" fill="#ffb81c"/><polygon points="93.7 86.04 85.56 94.18 59.96 68.57 68.09 60.44 93.7 86.04" fill="#fefefe" fillRule="evenodd"/><path d="M97.21,89.05l-8.14,8.14a1.26,1.26,0,0,0,0,1.76l25.61,25.61a1.25,1.25,0,0,0,1.77,0l8.13-8.13a1.25,1.25,0,0,0,0-1.77L99,89.05A1.27,1.27,0,0,0,97.21,89.05Zm.88,2.66,23.84,23.83-6.37,6.37L91.73,98.07Z" transform="translate(-30 -29.5)" fill="#0e497b"/><g>
          <line x1="57.29" y1="57.77" x2="63.55" y2="64.03" fill="none"/>
          <polygon points="59.77 55.3 66.02 61.55 61.07 66.5 54.82 60.25 59.77 55.3" fill="#0e497b"/>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'MagnifyingGlassIcon';

export default Icon;
